import { twMerge } from 'tailwind-merge';

interface TabListProps {
  children?: React.ReactNode;
  className?: string;
}

export const TabList = ({ children, className }: TabListProps) => {
  return (
    <div
      className={twMerge(
        'flex flex-wrap gap-4 max-sm:grid max-sm:grid-cols-1',
        className
      )}
    >
      {children}
    </div>
  );
};
